import React from 'react';
import {createDevlinkAtom} from '@packages/utilities/integrated-types';
import {iconName} from '@packages/systems/wfdl-Qualified';
import {Plugins, Atom} from '@packages/systems/wfdl';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {getChildren} from '@packages/utilities/data-utils';

const basicPlugin = Plugins.name('Basic');

const Superscript = Atom.createRender(
  ({attributes, classes, generateAttributes, data, innerHTML, renderChild}) => {
    return (
      <sup {...generateAttributes(attributes, classes)}>
        {/* @ts-expect-error - TS2322 - innerHTML union includes non-ReactNode array types (TODO platform: fix innerHTML type issues) */}
        {innerHTML || getChildren(data).map((child) => renderChild(child))}
      </sup>
    );
  }
);

const config = createDevlinkAtom({
  displayName: 'Superscript',
  icon: {type: 'Component', value: [basicPlugin, iconName('Superscript')]},
  showEmpty: false,
  render: Superscript,
  fields: {children: TListOfElement},
});

export default config;
